import { render, staticRenderFns } from "./commonHead.vue?vue&type=template&id=40c3c88e&"
import script from "./commonHead.vue?vue&type=script&lang=js&"
export * from "./commonHead.vue?vue&type=script&lang=js&"
import style0 from "./commonHead.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports